import { FormControl, FormGroup } from '@angular/forms';
import { NewShopModel } from './new.shop.model';
import { patchObject } from '../app/shared/util/object-util';
import { FormGroupHelper } from './forms/FormGroupHelper';
import { LoginControls } from './forms/builder/LoginFormBuilder';
import { IGenericBaryFormGroup } from './forms/GenericBaryFormGroup';

export interface NewShopControls {
  companyAddressCountry: FormControl;
  companyName: FormControl;
  name: FormControl;
  technicalName: FormControl;
  url: FormControl;
  primaryColor: FormControl;
  secondaryColor: FormControl;
  enableShop: FormControl;
  forceEdiTestMode: FormControl;
  fakeData: FormControl;
  moderator: IGenericBaryFormGroup<LoginControls>;
  domainName: FormControl;
}

export class NewShopFormGroupModel extends FormGroupHelper implements IGenericBaryFormGroup<NewShopControls> {
  protected declare readonly form: FormGroup;
  name = 'newShopForm';
  updated = false;
  controls: NewShopControls;

  constructor(formName: string, controls: NewShopControls) {
    super();
    this.name = formName;
    this.form = this.newFormGroup(controls);
    this.controls = controls;
  }

  value(): any {
    return this.form.value;
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  updateForm(model: NewShopModel): void {
    this.form.patchValue(model);
  }

  updateModel(model: NewShopModel): void {
    patchObject(model, this.form.value);
  }
}
